var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#4D12EE",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 24.14V22H35V24H31V22H28V24.14C26.28 24.59 25 26.14 25 28V40C25 41.1 25.9 42 27 42H39C40.1 42 41 41.1 41 40V28C41 26.14 39.72 24.59 38 24.14ZM39 40H27V28C27 26.9 27.9 26 29 26H37C38.1 26 39 26.9 39 28V40ZM37.5 32V36H35.5V34H28.5V32H37.5Z",
    fill: "#4D12EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.50c9150e6278ed74f45b3aae7d4c226e.svg";
export { ForwardRef as ReactComponent };